import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { DropdownModule } from 'ng2-bootstrap/dropdown';
import { FormsModule }   from '@angular/forms';
import { TabsModule } from 'ng2-bootstrap/tabs';
// Modal Component
import { ModalModule } from 'ng2-bootstrap/modal';  
// Components Routing
import { RepoagenciesRoutingModule } from './repoagencies-routing.module'; 
 
import { AgencyComponent } from './agency.component';
import { AddagentComponent } from './addagent.component'; 
import { AddagentpicComponent } from './addagentpic.component'; 
import { AddagentceoComponent } from './addagentceo.component'; 
import { ViewagentComponent } from './viewagent.component';
import { BroadcastComponent } from './broadcast.component';


import { ViewreporequestComponent } from './viewreporequest.component';
import { ReporequestComponent } from './reporequest.component';

import { RepossessedComponent } from './repossessed.component';

import { RepoComponent } from './repo.component';

// Service
import { AgencyService } from '../_Services/agency.service';
import { DebtService } from '../_Services/debt.service'; 
import { VehicleService } from '../_Services/vehicle.service';
// Pagination
import { NgxPaginationModule } from 'ngx-pagination';



@NgModule({
  imports: [
    RepoagenciesRoutingModule, 
    ModalModule.forRoot(), 
    CommonModule, 
    FormsModule,
    TabsModule,
    ChartsModule,
    DropdownModule,
    NgxPaginationModule
  ],
  declarations: [ 
      AgencyComponent,
      ViewagentComponent,
      AddagentComponent,
      AddagentpicComponent,
      AddagentceoComponent,
      BroadcastComponent,
      ViewreporequestComponent,
      ReporequestComponent,
      RepoComponent,
      RepossessedComponent
  ],
  providers: [
     AgencyService,
     DebtService,
     VehicleService
  ]
})
export class RepoagenciesModule { }



// WEBPACK FOOTER //
// ./src/app/repoagencies/repoagencies.module.ts